import React from 'react';
import { graphql } from 'gatsby';

import Layout from 'components/layout';
import FooterSection from 'sections/footer';
import Header from 'sections/header-subpage';
import Collaborators from 'sections/collaborators';
import GetStarted from 'sections/get-started';
import Informational from 'sections/informational';
import Markdown from 'sections/markdown';
import SEO from 'components/seo';

const CategoryTemplate = props => {
  const {
    heading,
    subheading,
    buttonLabel,
    image,
    content,
    seoTitle,
    seoDescription,
    ctaTitle,
  } = props;
  return (
    <Layout>
      <SEO title={seoTitle} description={seoDescription} />
      <Header
        title={heading}
        subtitle={subheading}
        buttonLabel={buttonLabel}
        image={image}
      />
      <Markdown source={content} />
      <Informational />
      <GetStarted title={ctaTitle} />
      <Collaborators />
      <FooterSection />
    </Layout>
  );
};

export default CategoryTemplate;

// export const query = graphql`
//   query CategoryTemplate($id: String!) {
//     strapiCategory(id: { eq: $id }) {
//       title
//       subtitle
//       content
//       image {
//         childImageSharp {
//           fluid(maxHeight: 1440, quality: 90) {
//             ...GatsbyImageSharpFluid_withWebp
//           }
//         }
//       }
//       seoTitle
//       seoDescription
//     }
//     allStrapiInformational {
//       nodes {
//         id
//         title
//         content
//         image {
//           childImageSharp {
//             fluid(maxHeight: 500, quality: 90) {
//               ...GatsbyImageSharpFluid_withWebp
//             }
//           }
//         }
//         imageAlt
//       }
//     }
//   }
// `;
